<template>

  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("powerTools.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/herramientas-electricas"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-electricas" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/power-tools" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/outillage-electriques" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-electricas" hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('powerTools.metaTitle'))">
      <meta name="description" :content="changeMetatagHtml($t('powerTools.metaDescription'))">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('powerTools.metaTitle'))">
      <meta property="og:description" :content="changeMetatagHtml($t('powerTools.metaDescription'))">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('powerTools.metaTitle'))">
      <meta property="twitter:description" :content="changeMetatagHtml($t('powerTools.metaDescription'))">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>

    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("powerTools.title") }}</h1>
            <h2 v-html="$t('powerTools.subTitle')" class="subTitle"></h2>
          </div>
        </div>

        <details>
          <summary v-html="$t('powerTools.summary.title')"></summary>
          <p v-html="$t('powerTools.summary.descriptionParagraph1')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph2')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph3')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph4')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph5')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph6')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph7')"></p>
          <p v-html="$t('powerTools.summary.descriptionParagraph8')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
                    <span
                        @click="filterData(filter)"
                        :class="{ active: filter === activeFilter }"
                    >
                      {{ $t(filter.text) }}
                    </span>
          </a>
        </div>

        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>

        <div v-else>
          <ArticlesList :articles="searchedArticles"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {computed, ref} from 'vue'
import {useRoute} from "vue-router";

export default {
  name: "PowerTools",
  components: {ArticlesList, Head},
  setup() {
    const route = useRoute();

    const subcategories = [
      'ELK04A1',
      'ELK04A10',
      'ELK01A055',
      'ELK12C00005',
      'ELK12C00010',
      'ELK12C00015',
      'ELK12C00020',
      'ELK12C00025',
      'ELK12C00035',
      'ELK12C00040',
      'ELK12C00045',
      'ELK12C00055',
      'ELK12C00060',
      'ELK12C00070',
      'ELK12C00073',
      'ELK12C00075',
      'ELK12C00090',
      'ELK12C00095',
      'ELK12C00110',
      'ELK12C00115',
      'ELK12C00120',
      'ELK12C00125',
      'ELK12C00135',
      'ELK12E001',
      'ELK12E010',
      'ELK12C000001',
      'ELK12C0000010',
      'ELK12C0000020',
      'ELK12C0000021',
      'ELK12C0000022',
      'ELK12C0000024',
      'ELK12C0000031',
      'ELK12C0000064',
      'ELK12C0000066',
      'ELK12C0000070',
      'ELK12C0000074',
      'ELK12C0000080',
      'ELK12C0000082',
      'ELK12C0000084',
      'ELK12C0000086',
      'ELK12C0000090',
      'ELK12C0000092',
      'ELK12C0000094',
      'ELK12C0000096',
      'ELK12C000009800',
      'ELK12C000009814'
    ]

    const filterMap = {
      all: 0,
      drillsAndScrewdrivers: 1,
      sawsAndSanders: 2,
      pressureWashers: 3,
      bateriesAndCargers: 4
    }

    const filtersRef = ref([
      {text: 'filtersArticles.all.text', code: []},
      {text: 'filtersArticles.drillsAndScrewdrivers.text', code: ['ELK12C000001', 'ELK12C0000010', 'ELK12C0000021', 'ELK12C00015', 'ELK12C00125']},
      {text: 'filtersArticles.sawsAndSanders.text', code: ['ELK12C0000022', 'ELK12C0000024', 'ELK12C00115', 'ELK12C00090', 'ELK12C00070', 'ELK12C00005']},
      {text: 'filtersArticles.pressureWashers.text', code: ['ELK12C0000070', 'ELK12C00060']},
      {text: 'filtersArticles.bateriesAndCargers.text', code: ['ELK12C00020']},
    ])

    const activeFilter = ref(filtersRef.value[0]);

    const filterFromRoute = filterMap[route.query.filter];
    if (filterFromRoute) {
      activeFilter.value = filtersRef.value[filterFromRoute];
    }

    const {articles, error, load} = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories)

    load()

    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    const searchedArticles = computed(() => {
      const activeCodes = Array.isArray(activeFilter.value?.code) ? activeFilter.value.code : [];

      if (activeCodes.length === 0) {
        return articles.value;
      }

      return articles.value.filter((article) =>
          activeCodes.includes(article.subcategoryCode)
      );
    });

    const filterData = (filter) => {
      activeFilter.value = filter;
    }
    console.log(searchedArticles)
    return {
      searchedArticles,
      filtersRef,
      activeFilter,
      error,
      GENERIC_VARIABLES,
      subcategories,
      changeMetatagHtml,
      filterData
    }


  }
}
</script>
